import React, {useCallback, useEffect, useState} from 'react';
import * as PropTypes from "prop-types";
import {compose} from 'redux';
import FacetComponent from './FacetComponent';
import {Box, Button, Container, Drawer, IconButton, TextField, Typography} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {withTranslation} from 'react-i18next';
import {useIsFetching} from '@tanstack/react-query'
import debounce from "lodash/debounce";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import {MuiBadge} from "../../MuiBadge";
import Constants from "../../../config/constants";

const SearchComponent = ({t, query, facetDistribution, facetDistributionData: propFacetDistributionData = null, updateQuery, facets, orderLabel, firstRegionId = null, orderList, hasTextualSearch = true}) => {
    const [openFilterDrawer, setOpenFilterDrawer ] = useState(false);
    const [q, setQ] = useState(query.q);
    const isFetching = useIsFetching();


    const clearFacets = () => {
        const updatedQuery = {...query, choices: [],};
        updateQuery(updatedQuery);
    };

    const toggleDrawer = (isOpen) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpenFilterDrawer(isOpen);
    };

    const updateOrder = (event, value) => {
        console.log('updateOrder', value);
        if (value !== null) {
            // if (value === Constants.RouteListComponent.queryOrder.region) {
            //     updateQuery({...query, order: value, openRegionId: firstRegionId, offset: 0});
            // } else {
                updateQuery({...query, order: value, openRegionId: null, offset: 0});
            //}
        }
    };

    const updateFacet = (name, selected)=> {
        const updateChoices = query.choices;
        const index = updateChoices.findIndex(x => x.name === name);

        let choice;
        if (index === -1) {
            choice = {
                name: name,
                selected: selected,
            };
            updateChoices.push(choice);
        } else {
            choice = updateChoices[index];

            choice.selected = selected;
            updateChoices[index] = choice;
        }

        updateQuery({...query, choices: updateChoices});
    };

    const updateQ = () => {
        const order = query.order === Constants.RouteListComponent.queryOrder.region ? Constants.RouteListComponent.queryOrder.list : query.order;
        updateQuery({...query, q: q, order: order});
    };

    const submitQuery = () => {
        setOpenFilterDrawer(false);
    };

    //const nbFilter = query.choices.length;
    let nbFilter = 0;
    query.choices.forEach((choice) => {
        if (choice?.selected && choice.selected.length > 0) {
            nbFilter += choice.selected.length;
        }
    });

    const handleClearClick = () => {
        setQ("");
        updateQuery({...query, q: ""});
    };

    const delayedQuery = useCallback(debounce(q => {
        if (query.q === q) {
            return;
        }
        window.history.pushState('data', null, window.location.origin + window.location.pathname + '?q=' + encodeURI(q));
        const order = query.order === Constants.RouteListComponent.queryOrder.region ? Constants.RouteListComponent.queryOrder.list : query.order;
        return updateQuery({...query, q: q, order: order});
    }, 300), [query]);

    useEffect(() => {
        delayedQuery(q);
    }, [q]);

    return (<>
    {hasTextualSearch && <Box display="flex" py={1} pl={1} pr={1} alignItems="center">
        <Box flexGrow={1} pr={1}>
            <TextField id="outlined-basic"
                       label={t("SearchComponent.field.search.label")}
                       placeholder={t("SearchComponent.field.search.placeholder")}
                       variant="outlined"
                       size="small"
                       value={q}
                       onKeyDown={(event) => { if(event.key === "Enter" && q.length > 0) {updateQ();}}}
                       onChange={(event) => { setQ(event.target.value); /*delayedQuery(event.target.value);*/}}
                       fullWidth={true}
                       InputProps={{
                           endAdornment: (
                               <>
                                   {q.length > 0 && <IconButton
                                       size="small"
                                       onClick={handleClearClick}
                                   >
                                       <FontAwesomeIcon icon={["fas", "times"]}  className="primary" />
                                   </IconButton>}
                               </>
                           ),
                       }}
            />
        </Box>
        <Box>
            <IconButton aria-label={t("SearchComponent.button.search")}
                        size="small"
                        onClick={updateQ}
            >
                <FontAwesomeIcon icon={["fas", "search"]}  className="primary" />
            </IconButton>
        </Box>
    </Box>}
    <Box display="flex" py={1} pl={1} pr={1} alignItems="center">
        <Box flexGrow={1}>
            <MuiBadge badgeContent={nbFilter} color="tertiary" onClick={toggleDrawer(true)}>
                <IconButton aria-label={t("SearchComponent.button.filter")}
                            onClick={toggleDrawer(true)}
                            size="small"
                            color="primary"
                >
                    <FontAwesomeIcon icon={["fas", "filter"]}  className="primary" />
                    &nbsp; {t("SearchComponent.button.filter")}
                </IconButton>
            </MuiBadge>
            <Drawer anchor={'left'} open={openFilterDrawer} onClose={toggleDrawer(false)} width="90%">
                {openFilterDrawer && <div
                    className={"listDrawer"}
                    role="presentation"
                >
                    <Box display="flex" p={1} alignItems="center">
                        <Box>
                            <Typography variant="h3">{t("SearchComponent.title")}</Typography>
                        </Box>
                        <Box flexGrow={1}>
                            {Array.isArray(query.choices) && query.choices.length > 0 && <Button onClick={clearFacets}>
                                {t('SearchComponent.button.clearAll')}
                            </Button>}
                        </Box>
                        <Box>
                            {isFetching > 0 && <FontAwesomeIcon icon={["fas", "spinner"]} spin />}
                            <IconButton aria-label={t("SearchComponent.button.close")}
                                        onClick={toggleDrawer(false)}
                                        size="small"
                            >
                                <FontAwesomeIcon icon={["fas", "times"]}  className="secondary" />
                            </IconButton>
                        </Box>
                    </Box>
                    <div className={"flexGrow"}>
                        {facetDistribution && facetDistribution.map((facetDistribution) => {
                            if (!Array.isArray(facets)) {
                                return '';
                            }

                            const facet = facets.find(f => f.name === facetDistribution.name);
                            const facetDistributionData = Array.isArray(propFacetDistributionData) ? propFacetDistributionData[facetDistribution.name] : null;
                            const choice = query.choices.find(c => c?.name === facet?.name);
                            let selected = [];

                            if (typeof choice !== "undefined" && Array.isArray(choice.selected)) {
                                selected = choice.selected;
                            }

                            return (<FacetComponent
                                facet={facet}
                                facetDistribution={facetDistributionData}
                                display={facetDistribution.display}
                                updateFacet={updateFacet}
                                choices={selected}
                                key={facetDistribution.name}
                            />);
                        })}
                    </div>
                    <div>
                        <Box display="flex" p={1}>
                            <Box flexGrow={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{width: "100%"}}
                                    onClick={submitQuery}>
                                    {t("SearchComponent.button.submit")}
                                </Button>
                            </Box>
                        </Box>
                    </div>
                </div>}
            </Drawer>
        </Box>
        <Box pl={1} style={{textAlign: "right"}}>
                <ToggleButtonGroup
                    value={query.order}
                    exclusive
                    onChange={updateOrder}
                    aria-label="View"
                    inputprops={{
                        name: 'sort',
                        id: 'sort-native-helper',
                    }}
                >
                    {orderList.map((option) => (
                        <ToggleButton  key={option.value} value={option.value}>{option.label}</ToggleButton>
                    ))}
                </ToggleButtonGroup>
        </Box>
    </Box>
    </>);
};

SearchComponent.defaultProps = {
    updateQuery: PropTypes.function,
    query: {},
    facets: PropTypes.array,
    facetDistribution: PropTypes.array,
    setQuery: null,
};

export default compose(
    withTranslation()
)(SearchComponent);
